import React from 'react';
import BookDemoButton from '../../BookDemoButton';
import { BetaAlertText, BetaAlertWrapper, ConnectorIconBetaLabelBig } from './Styles';

type BetaAlertProps = {};

const BetaAlert: React.FC<BetaAlertProps> = (props) => {
	return (
		<BetaAlertWrapper>
			<ConnectorIconBetaLabelBig>BETA</ConnectorIconBetaLabelBig>
			<BetaAlertText>
				This connector is currently being trialed with specific users and will be opened to general release
				shortly. If you would like to be involved in the beta trial of the connector please get in touch.
			</BetaAlertText>
			<BookDemoButton isForMobile={false} textOverride={'APPLY FOR BETA ACCESS'} />
		</BetaAlertWrapper>
	);
};

export default BetaAlert;
